import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
  padding: 0 0.4rem 0 0.4rem;
  width: 100%;
`

export const CustomFieldMui = styled(TextFieldMui)`
  width: 100%;
`
